<template>
    <div class="">
        <div class="top_title">
            <div class="top_back_home" @click="backToindex">
                <img src="../../../public/images/home.png" alt=""/>
                <p>返回首页</p>
            </div>
            <div class="title">
                订单管理
            </div>
        </div>
        <div class="main">
            <div class="order_top">
                <div class="time">
<!--                    记账时间：{{ date }}-->
<!--                    <img src="../../../public/images/date.png" alt=""/>-->
                    <el-date-picker
                        v-model="date"
                        :clearable="false"
                        @change="changeDate"
                        value-format="yyyy-MM-dd"
                        format="yyyy-MM-dd"
                        type="date"
                        placeholder="选择日期">
                    </el-date-picker>

                </div>
                <div class="box">
                    <div class="tt">
                        <div class="item">
                            <h3>{{ statistics.income }}</h3>
                            <p>今日收入（元）</p>
                        </div>
                        <div class="item">
                            <h3>{{ statistics.expend }}</h3>
                            <p>今日支出（元）</p>
                        </div>
                        <div class="item">
                            <h3>{{ statistics.profit }}</h3>
                            <p>今日利润（元）</p>
                        </div>
                    </div>
                    <div class="bb">
                        <p>今日宰羊：</p>
                        <el-input v-model="today.today" placeholder="今日宰羊"></el-input>
                        <el-input v-model="today.surplus" placeholder="剩余"></el-input>
                        <el-button type="primary" @click="saveToday">保存</el-button>
                    </div>
                </div>
            </div>
            <div class="tab_title">
                <div v-for="(item, index) in items" :key="item.id" class="item"
                     :class="{ 'active': item.id === activeId }" @click="setActive(item.id)">
                    {{ item.title }}
                </div>
            </div>

            <!-- 收入明细 -->
            <div class="shouru_mingxi" v-if="activeId === 1">
                <div class="today_income">
                    <div class="title">
                        <div class="left">
                            今日收入（{{ date }}）
                        </div>
                        <div class="right">
                            合计：<p>￥{{ todayIncomeTotal }}</p>
                        </div>
                    </div>
                    <div class="table">
                        <el-table :data="todayIncomeList" style="width: 100%">
                            <el-table-column prop="any_product_name" label="商品">
                            </el-table-column>
                            <el-table-column prop="total_number" label="数量">
                            </el-table-column>
                            <el-table-column prop="total" label="总金额">
                            </el-table-column>
                        </el-table>
                    </div>
                </div>

                <div class="sales_man" v-for="(item, key) in saleList">
                    <div class="title">
                        <div class="left">
                            销售员：{{ item.sale_name }}
                        </div>
                        <div class="right">
                            合计：<p>￥{{ item.total_fee }}</p>
                        </div>
                    </div>
                    <el-col style="margin:20px;">
                        <el-descriptions >
                            <el-descriptions-item
                                v-for="product in item.product_list"
                                :label="product.product_name">{{ product.number && (Math.round(product.number * 100) / 100).toFixed(2) }}公斤（<span style="color: #f56c6c;font-weight: bold;">¥{{ product.total_fee }}</span>）</el-descriptions-item>
                        </el-descriptions>
                    </el-col>

<!--                    <div class="sales_product">-->
<!--                        <div class="item" v-for="product in item.product_list">-->
<!--                            {{ product.product_name }}：{{ product.number }}公斤（¥{{ product.total_fee }}）-->
<!--                        </div>-->
<!--                    </div>-->
                    <div class="table">
                        <el-table :data="item.list" style="width: 100%" border>
                            <el-table-column prop="time" label="时间">
                            </el-table-column>
                            <el-table-column prop="customer_name" label="客户">
                            </el-table-column>
                            <el-table-column prop="product_name" label="商品">
                            </el-table-column>
                            <el-table-column prop="number" label="数量">
                            </el-table-column>
                            <el-table-column prop="price" label="单价">
                            </el-table-column>
                            <el-table-column prop="total_fee" label="总金额">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.is_offal == 1">{{ scope.row.total_fee }}</span>
                                    <del v-if="scope.row.is_offal == 2">{{ scope.row.total_fee }}</del>
                                </template>
                            </el-table-column>
                            <el-table-column prop="batch_name" label="批次">
                            </el-table-column>
                            <el-table-column prop="is_back" label="还款状态" width="100">
                                <template slot-scope="scope">
                                    <el-tag size="small" :type="scope.row.is_back == 1 ? 'danger' : 'success'"
                                            disable-transitions>{{ scope.row.is_back == 1 ? '未还款' : '已还款' }}
                                    </el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column fixed="right" label="操作" width="100">
                                <template slot-scope="scope">
                                    <el-button type="text" size="small" @click="orderExit(key, scope.$index)">编辑</el-button>
                                    <el-button @click="delOrderDetail(scope.row)" type="text" size="small"
                                               style="color: #CB2D18;">删除
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>

            <!-- 支出明细 -->
            <div class="zhichu_mingxi" v-if="activeId === 2">
                <div class="today_goout">
                    <div class="title">
                        <div class="left">
                            今日支出（{{ date }}）
                            <div class="ll">
                                合计：<span>￥{{ expendTotal }}</span>
                            </div>
                        </div>
                        <div class="right">
                            <div class="itt" @click="chengBen(1)">
                                <img src="../../../public/images/set.png" alt=""/>
                                成本组成管理
                            </div>
<!--                            <div class="itt" @click="saveExpend">-->
<!--                                <img src="../../../public/images/save.png" alt=""/>-->
<!--                                保存-->
<!--                            </div>-->
                        </div>
                    </div>
                    <div class="table">
                        <el-table :data="expendList" style="width: 100%">
                            <el-table-column prop="cost_id" label="成本名称" width="200">
                                <template slot-scope="scope">
                                    <el-select v-model="scope.row.cost_id" placeholder="请选择成本名称">
                                        <el-option v-for="item in costList" :key="item.id" :label="item.name"
                                                   :value="item.id">
                                        </el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column prop="money" label="金额" width="200">
                                <template slot-scope="scope">
                                    <el-input type="number" v-model="scope.row.money" :min="0"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="remark" label="备注">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.remark" ></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="100">
                                <template slot-scope="scope">
                                    <el-button size="mini" type="danger"
                                               @click="delExpend(scope.$index)">删除
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="actions">
                            <el-button @click="addDataGoOutRow">+ 新增</el-button>
                        </div>
                        <div class="submit">
                            <el-button @click="saveExpend">保存</el-button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 编辑订单弹窗 -->
            <div v-if="showDialogOrderExit" class="dialog-overlay">
                <div class="dialog-content">
                    <div class="dialog-header">
                        编辑订单
                        <img @click="closeDialogOrderExit" src="../../../public/images/close.png" alt=""/>
                    </div>
                    <div class="dialog-body">
                        <div class="item">
                            <div class="title">
                                客户<span>*</span>
                            </div>
                            <div class="con">
                                <el-select v-model="editOrderDetail.customer_id" placeholder="请选择客户">
                                    <el-option v-for="item in customerList" :key="item.id" :label="item.name"
                                               :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="item">
                            <div class="title">
                                商品<span>*</span>
                            </div>
                            <div class="con">
                                <el-input v-model="editOrderDetail.product_name" :disabled="true">
                                </el-input>
                            </div>
                        </div>
                        <div class="item">
                            <div class="title">
                                数量<span>*</span>
                            </div>
                            <div class="con">
                                <el-input type="number" :min="0" @change="changeEditOrderDetail" placeholder="请输入数量" v-model="editOrderDetail.number">
                                </el-input>
                            </div>
                        </div>
                        <div class="item">
                            <div class="title">
                                单价<span>*</span>
                            </div>
                            <div class="con">
                                <el-input type="number" :min="0" @change="changeEditOrderDetail" placeholder="请输入单价" v-model="editOrderDetail.price">
                                </el-input>
                            </div>
                        </div>
                        <div class="item">
                            <div class="title">
                                总金额<span>*</span>
                            </div>
                            <div class="con">
                                <el-input placeholder="请输入内容" v-model="editOrderDetail.total_fee" :disabled="true">
                                </el-input>
                            </div>
                        </div>
                        <div class="control">
                            <div class="itt quxiao" @click="closeDialogOrderExit">
                                取消
                            </div>
                            <div class="itt sure" @click="sureOrderExit">
                                确认
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 成本组成管理弹窗 -->
            <div v-if="showDialogChengBen" class="dialog-overlay chengben">
                <div class="dialog-content">
                    <div class="dialog-header">
                        <div class="left">
                            成本组成管理
                        </div>
                        <div class="right" @click="addChengBenNameRow">
                            <img src="../../../public/images/add.png" alt=""/>
                            <p>添加成本名称</p>
                        </div>

                    </div>
                    <div class="dialog-body">
                        <el-table :data="costList" style="width: 100%" height="300">
                            <el-table-column prop="name" label="成本名称" width="200">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.name"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="desc" label="描述">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.desc"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <el-button size="mini" type="danger"
                                               @click="delCost(scope.$index)">删除
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="control">
                            <div class="itt quxiao" @click="closeDialogChengBen">
                                取消
                            </div>
                            <div class="itt sure" @click="saveCost">
                                确认保存
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            today: {
                today: '',
                surplus: '',
            },
            date: '', // 日期
            statistics: {}, // 统计
            //今日收入
            todayIncomeList: [],
            todayIncomeTotal: '',
            // tab 切换数据
            items: [
                {
                    id: 1,
                    title: '收入明细'
                },
                {
                    id: 2,
                    title: '支出明细'
                }
            ],
            activeId: 1, // 当前激活的元素 ID

            // 销售员销售列表
            saleList: [],
            // 编辑订单
            customerList: [],
            editOrderDetail: {},
            showDialogOrderExit: false,

            //支出明细
            expendList: [],
            expendTotal: 0,

            //成本组成管理
            showDialogChengBen: false,
            costList: [],
        }
    },
    mounted() {
        this.date = this.getCurrentDate();
        this.getPageData();
    },
    methods: {
        getCurrentDate() {
            const today = new Date();
            const year = today.getFullYear();
            const month = String(today.getMonth() + 1).padStart(2, '0'); // 月份是从0开始的
            const day = String(today.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        //返回首页
        backToindex() {
            this.$router.push({
                path: '/',
            })
        },
        changeDate(){
            this.getPageData();
            this.getExpendList();
        },
        getPageData(){
            const loading = this.$loading({
                lock: true,
                text: '',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$http.post('/order/getPageData', {date: this.date}).then(res => {
                loading.close();
                if (res.data.code == 0) {
                    this.today = res.data.data.today;
                    this.todayIncomeList = res.data.data.todayIncomeList;
                    var todayIncomeTotal = 0;
                    for (var i=0; i<res.data.data.todayIncomeList.length; i++) {
                        todayIncomeTotal += (+res.data.data.todayIncomeList[i].total);
                    }
                    this.todayIncomeTotal = todayIncomeTotal;
                    this.saleList = res.data.data.list;
                    this.statistics = res.data.data.statistics;

                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.msg
                    })
                }
            });
        },
        // 获取支出数据
        getExpendList(){
            this.chengBen(0);
            const loading = this.$loading({
                lock: true,
                text: '',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$http.post('/expend/getExpendList',{date: this.date}).then(res => {
                loading.close();
                if (res.data.code == 0) {
                    this.expendList = res.data.data.expendList;
                    var expendTotal = 0;
                    for (var i=0; i<res.data.data.expendList.length; i++) {
                        expendTotal += (+res.data.data.expendList[i].money);
                    }
                    this.expendTotal = expendTotal;
                    this.statistics = res.data.data.statistics;
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.msg
                    })
                }
            });
        },

        // 保存今日宰羊
        saveToday(){
            const loading = this.$loading({
                lock: true,
                text: '',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.today.time = this.date;
            this.$http.post('/order/editToday', this.today).then(res => {
                loading.close();
                if (res.data.code == 0) {
                    this.$message({
                        message: "保存成功！",
                        type: "success",
                    });
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.msg
                    })
                }
            });
        },
        //点击切换
        setActive(id) {
            this.activeId = id;
            if(id == 1){
                // 收入
                this.getPageData();
            }else{
                // 支出
                this.getExpendList();
            }
        },
        delOrderDetail(row) {
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const loading = this.$loading({
                    lock: true,
                    text: '',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.$http.post('/order/delOrderDetail', {
                    id: row.id,
                }).then(res => {
                    loading.close();
                    if (res.data.code == 0) {
                        this.$message({
                            message: "操作成功",
                            type: "success",
                        });
                        this.getPageData();
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                });
            }).catch(() => {

            });
        },

        // 编辑订单弹窗
        orderExit(key, index) {
            this.editOrderDetail = this.saleList[key].list[index];
            this.customerList = [];
            // 获取客户
            var loading = this.$loading({
                lock: true,
                text: '',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$http.get('/customer/getCustomerList?sale_id=' + this.editOrderDetail.sale_id).then(res => {
                loading.close();
                if (res.data.code == 0) {
                    this.customerList = res.data.data;
                    this.showDialogOrderExit = true;
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.msg
                    })
                }
            });
        },
        changeEditOrderDetail(){
            this.editOrderDetail.total_fee = parseInt((+this.editOrderDetail.number) * (+this.editOrderDetail.price), 10);
        },
        closeDialogOrderExit() {
            this.showDialogOrderExit = false;
        },
        sureOrderExit(){
            const loading = this.$loading({
                lock: true,
                text: '',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$http.post('/order/editOrderDetail', this.editOrderDetail).then(res => {
                loading.close();
                if (res.data.code == 0) {
                    this.$message({
                        message: "操作成功！",
                        type: "success",
                    });
                    this.closeDialogOrderExit();
                    this.getPageData();
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.msg
                    })
                }
            });
        },
        //新增支出
        addDataGoOutRow() {
            this.expendList.push({
                id: 0,
                cost_id: this.costList.length > 0 ? this.costList[0].id : 0,
                name: '',
                desc: '',
                money: 0,
                remark: '',
            });
        },
        delExpend(index){
            if(this.expendList[index].id <= 0){
                var newExpendList = [];
                for (var i=0; i<this.expendList.length; i++) {
                    if(i != index){
                        newExpendList.push(this.expendList[i]);
                    }
                }
                this.expendList = newExpendList;
                return false;
            }
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const loading = this.$loading({
                    lock: true,
                    text: '',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.$http.post('/expend/delete', {
                    id: this.expendList[index].id,
                }).then(res => {
                    loading.close();
                    if (res.data.code == 0) {
                        this.$message({
                            message: "操作成功",
                            type: "success",
                        });
                        var newExpendList = [];
                        for (var i=0; i<this.expendList.length; i++) {
                            if(i != index){
                                newExpendList.push(this.expendList[i]);
                            }
                        }
                        this.expendList = newExpendList;
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                });
            }).catch(() => {

            });
        },
        saveExpend(){
            var loading = this.$loading({
                lock: true,
                text: '',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$http.post('/expend/saveExpend', {
                data: this.expendList,
                date: this.date,
            }).then(res => {
                loading.close();
                if (res.data.code == 0) {
                    this.getExpendList();
                    this.$message({
                        message: "保存成功！",
                        type: "success",
                    });
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.msg
                    })
                }
            });
        },

        // 成本组成管理弹窗
        chengBen(isShow = 1) {
            var loading;
            if(isShow == 1){
                loading = this.$loading({
                    lock: true,
                    text: '',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
            }
            this.$http.get('/cost/getCostList').then(res => {
                if(isShow == 1) {
                    loading.close();
                }
                if (res.data.code == 0) {
                    this.costList = res.data.data;
                    if(isShow == 1){
                        this.showDialogChengBen = true;
                    }
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.msg
                    })
                }
            });
        },
        closeDialogChengBen() {
            this.showDialogChengBen = false;
        },
        addChengBenNameRow() {
            this.costList.push({
                id: 0,
                name: '',
                desc: '',
            });
        },
        saveCost(){
            const loading = this.$loading({
                lock: true,
                text: '',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$http.post('/cost/saveCost', {data: this.costList}).then(res => {
                loading.close();
                if (res.data.code == 0) {
                    this.$message({
                        message: "操作成功",
                        type: "success",
                    });
                    this.closeDialogChengBen();
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.msg
                    })
                }
            });
        },
        delCost(index){
            if(this.costList[index].id <= 0){
                var newCostList = [];
                for (var i=0; i<this.costList.length; i++) {
                    if(i != index){
                        newCostList.push(this.costList[i]);
                    }
                }
                this.costList = newCostList;
                return false;
            }
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const loading = this.$loading({
                    lock: true,
                    text: '',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.$http.post('/cost/delete', {
                    id: this.costList[index].id,
                }).then(res => {
                    loading.close();
                    if (res.data.code == 0) {
                        this.$message({
                            message: "操作成功",
                            type: "success",
                        });
                        var newCostList = [];
                        for (var i=0; i<this.costList.length; i++) {
                            if(i != index){
                                newCostList.push(this.costList[i]);
                            }
                        }
                        this.costList = newCostList;
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                });
            }).catch(() => {

            });
        },
    }
}
</script>

<style lang="less" scoped>
.main {
    padding: 0 20px;
    box-sizing: border-box;

    .order_top {
        margin-top: 16px;

        .time {
            display: flex;
            align-items: center;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 24px;
            color: #FFFFFF;
            line-height: 36px;
            margin-bottom: 20px;

            img {
                display: block;
                width: 36px;
                height: 36px;
                margin-left: 12px;
            }
        }

        .box {
            background: #FFFFFF;
            border-radius: 8px 8px 8px 8px;
            padding: 20px;

            .tt {
                display: flex;
                align-items: center;
                margin-bottom: 24px;

                .item {
                    border-right: 1px solid #F0F0F0;
                    flex: 1;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    box-sizing: border-box;

                    h3 {
                        font-family: DIN, DIN;
                        font-weight: 500;
                        font-size: 32px;
                        color: #3F72FF;
                    }

                    p {
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #4A5676;
                    }
                }

                .item:nth-child(2) {
                    h3 {
                        color: #FF7700;
                    }
                }

                .item:last-child {
                    border: 0;

                    h3 {
                        color: #389F0D;
                    }
                }
            }

            .bb {
                display: flex;
                align-items: center;

                p {
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 500;
                    font-size: 18px;
                    color: #36363A;
                }

                .el-input {
                    flex: 1;
                    padding: 0 10px;
                    box-sizing: border-box;
                }
            }

        }
    }

    .tab_title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 20px 0px;

        .item {
            flex: 0 0 48%;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 20px;
            color: #3F72FF;
            line-height: 50px;
            cursor: pointer;
            border-radius: 50px;
            border: 1px solid #3F72FF;
            text-align: center;
            box-sizing: border-box;
        }

        .item.active {
            color: #fff;
            position: relative;
            background: #3F72FF;
            border: 1px solid #3F72FF;
        }

        .item.active::after {
            //content: '';
            //display: block;
            //position: absolute;
            //left: 50%;
            //bottom: -10px;
            //transform: translate(-50%, 0);
            //width: 25px;
            //height: 5px;
            //background: #3F72FF;
        }
    }

    .today_income {
        background: #FFFFFF;
        border-radius: 8px 8px 8px 8px;
        padding: 20px;
        margin-bottom: 20px;

        .title {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .left {
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 18px;
                color: #36363A;
                line-height: 28px;
                padding-left: 8px;
                position: relative;
            }

            .left::after {
                content: '';
                display: block;
                position: absolute;
                left: 0;
                top: 5px;
                width: 4px;
                height: 18px;
                background: #3F72FF;
                border-radius: 12px 12px 12px 12px;
            }

            .right {
                display: flex;
                align-items: center;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #3D3D3D;

                p {
                    font-family: DIN, DIN;
                    font-weight: 500;
                    font-size: 18px;
                    color: #3D3D3D;
                }
            }
        }
    }

    .today_goout {
        background: #FFFFFF;
        border-radius: 8px 8px 8px 8px;
        padding: 20px;
        margin-bottom: 20px;

        .title {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .left {
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 18px;
                color: #36363A;
                line-height: 28px;
                padding-left: 8px;
                position: relative;
                display: flex;
                align-items: center;

                .ll {
                    display: flex;
                    align-items: center;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #3D3D3D;

                    span {
                        font-family: DIN, DIN;
                        font-weight: 500;
                        font-size: 18px;
                        color: #3D3D3D;
                    }
                }
            }

            .left::after {
                content: '';
                display: block;
                position: absolute;
                left: 0;
                top: 5px;
                width: 4px;
                height: 18px;
                background: #3F72FF;
                border-radius: 12px 12px 12px 12px;
            }

            .right {
                display: flex;
                align-items: center;

                .itt {
                    display: flex;
                    align-items: center;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 16px;
                    color: #3F72FF;
                    margin-left: 22px;
                    cursor: pointer;

                    img {
                        display: block;
                        width: 16px;
                        height: 16px;
                        margin-right: 6px;
                    }
                }
            }
        }

        .table {
            .actions {
                width: 100%;
                border-radius: 4px 4px 4px 4px;
                border: 1px dashed #C1D0FB;
                text-align: center;
                margin-top: 8px;

                .el-button {
                    margin: 0 auto;
                    border: 0;
                    padding: 0;
                    line-height: 40px;
                    height: 40px;
                    width: 100%;
                    display: block;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 16px;
                    color: #3F72FF;
                }
            }
            .submit {
                margin-top: 30px;
                width: 100%;
                border-radius: 60px;
                line-height: 60px;
                text-align: center;

                .el-button {
                    background: #3F72FF;
                    margin: 0 auto;
                    border: 0;
                    padding: 0;
                    line-height: 60px;
                    height: 60px;
                    border-radius: 60px;
                    width: 100%;
                    display: block;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 500;
                    font-size: 18px;
                    color: #FFFFFF;
                }
            }
        }
    }

    .sales_man {
        background: #FFFFFF;
        border-radius: 8px 8px 8px 8px;
        padding: 20px;
        margin-bottom: 20px;

        .title {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .left {
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 18px;
                color: #36363A;
                line-height: 28px;
                padding-left: 8px;
                position: relative;
            }

            .left::after {
                content: '';
                display: block;
                position: absolute;
                left: 0;
                top: 5px;
                width: 4px;
                height: 18px;
                background: #3F72FF;
                border-radius: 12px 12px 12px 12px;
            }

            .right {
                display: flex;
                align-items: center;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #3D3D3D;

                p {
                    font-family: DIN, DIN;
                    font-weight: 500;
                    font-size: 18px;
                    color: #3D3D3D;
                }
            }
        }
        .sales_product{
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            width: 80%;
            .item{
                flex: 0 0 33%;
                font-size: 16px;
                line-height: 35px;
                border-bottom: 1px solid #3F72FF;
                box-sizing: border-box;
                padding-left: 15px;
            }
        }
    }

    .dialog-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 2000;

        .dialog-content {
            background: white;
            border-radius: 8px;
            width: 80%;
            max-width: 90%;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
            padding: 24px;

            .dialog-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 18px;
                color: #4A5676;
                margin-bottom: 26px;

                img {
                    display: block;
                    width: 24px;
                    height: 24px;
                    cursor: pointer;
                }
            }

            .dialog-body {
                .item {
                    margin-bottom: 20px;

                    .title {
                        display: flex;
                        align-items: center;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 16px;
                        color: #36363A;
                        margin-bottom: 12px;

                        span {
                            color: #CB2D18;
                        }
                    }
                }

                .control {
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    margin-top: 20px;

                    .itt {
                        width: 96px;
                        height: 40px;
                        border-radius: 4px 4px 4px 4px;
                        box-sizing: border-box;
                        line-height: 40px;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 16px;
                        text-align: center;
                        margin-left: 16px;
                        cursor: pointer;
                    }

                    .quxiao {
                        border: 1px solid #E5E5E7;
                        color: #36363A;

                    }

                    .sure {
                        background: #3F72FF;
                        border: 1px solid #3F72FF;
                        color: #FFFFFF;
                    }
                }
            }
        }
    }

    .chengben {
        .dialog-header {
            .right {
                display: flex;
                align-items: center;
                cursor: pointer;

                p {
                    color: #3F72FF;
                }
            }
        }
    }

}
</style>
